import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const CTA = () => {
  const emailInputRef = useRef(null);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const email = emailInputRef.current?.value;
    if (email) {
      navigate(`/demo?email=${encodeURIComponent(email)}`);
    }
  };

  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-indigo-900 via-indigo-950 to-black">
      <div className="container px-4 mx-auto">
        <div className="max-w-5xl mx-auto bg-gradient-to-r from-slate-800/90 to-slate-700 rounded-3xl overflow-hidden shadow-xl reveal fade-bottom border border-slate-500/30">
          <div className="grid md:grid-cols-5">
            {/* Lado izquierdo con contenido de CTA */}
            <div className="p-8 md:p-12 md:col-span-3 flex flex-col justify-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Ready to simplify your cloud infrastructure?
              </h2>
              <p className="text-blue-100 mb-8 text-lg">
                Get started with Cloudima today and transform how your team designs, deploys, and manages cloud resources.
              </p>

              {/* Formulario de correo electrónico */}
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label htmlFor="email-cta" className="sr-only">
                    Email address
                  </label>
                  <input
                    ref={emailInputRef}
                    id="email-cta"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    placeholder="Enter your email address"
                    className="block w-full rounded-lg border-0 px-4 py-3 text-gray-900 shadow-sm ring-1 ring-inset ring-white/10 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-white sm:text-sm"
                  />
                </div>
                <button
                  type="submit"
                  className="flex w-full justify-center items-center rounded-lg bg-white px-4 py-3 text-sm font-semibold text-blue-700 shadow-sm hover:bg-blue-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white transition-colors duration-200"
                  style={{ color: '#4c51bf' }}
                >
                  Start For Free
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5 ml-2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                    />
                  </svg>
                </button>
              </form>

            </div>

            {/* Lado derecho con ilustración/imagen */}
            <div className="hidden md:flex md:col-span-2 items-center justify-center bg-gradient-to-br from-slate-900 to-slate-800 relative overflow-hidden">
              <div className="absolute inset-0 opacity-20">
                <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(#fff_1px,transparent_1px)]" style={{ backgroundSize: '20px 20px' }}></div>
              </div>

              {/* Formas abstractas */}
              <div className="relative z-10 p-8">
                <div className="w-64 h-64 relative">
                  {/* Icono de nube */}
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-20 h-20 bg-white rounded-full flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-12 h-12"
                      style={{ color: '#4c51bf' }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z"
                      />
                    </svg>
                  </div>

                  {/* Círculos circundantes */}
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-10 h-10 bg-[#4c51bf] rounded-full flex items-center justify-center animate-float">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6 text-white"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"
                      />
                    </svg>
                  </div>
                  <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-10 h-10 bg-[#4c51bf] rounded-full flex items-center justify-center animate-float animation-delay-2000">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6 text-white"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"
                      />
                    </svg>
                  </div>
                  <div className="absolute top-1/2 left-0 transform -translate-y-1/2 w-10 h-10 bg-[#4c51bf] rounded-full flex items-center justify-center animate-float animation-delay-1000">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6 text-white"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
                      />
                    </svg>
                  </div>
                  <div className="absolute top-1/2 right-0 transform -translate-y-1/2 w-10 h-10 bg-[#4c51bf] rounded-full flex items-center justify-center animate-float animation-delay-3000">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6 text-white"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Partners Section */}
      <div className="container px-4 mx-auto mt-16">
        <div className="text-center mb-4">
          <p className="text-blue-100 text-sm font-medium mb-2">TRUSTED BY LEADING COMPANIES</p>
          <h3 className="text-xl font-semibold text-white">Our Partners</h3>
        </div>

        <div className="flex justify-center items-center space-x-8">
          {/* Nuevo Partner Logo */}
          <img
            src="https://cloudima-landing-media.s3.eu-west-1.amazonaws.com/images/partners/DevCloudPartners.png"
            alt="Nuevo Partner"
            className="h-6 md:h-8 w-auto opacity-80 hover:opacity-100 transition-opacity duration-200"
          />
          
          {/* K8Studio Partner */}
          <img
            src="https://cloudima-landing-media.s3.eu-west-1.amazonaws.com/images/partners/k8studio.png"
            alt="K8Studio Partner"
            className="h-6 md:h-8 w-auto opacity-80 hover:opacity-100 transition-opacity duration-200"
          />
        </div>
      </div>
    </section>
  );
};

export default CTA; 